import React, { Component } from 'react';
import { Button, Select } from 'antd';
import styled from "styled-components"
// import UploadAPI from '@/API/upload'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

const Option = Select.Option;

const Div=styled.div`
  padding: 20px;
  &:after{
    content: "";
    display: table;
    clear: both;
  }
`

const AddButton=styled(Button)`
  float:right;
  margin-right:20px;
`
const DeleteButton=styled(Button)`
  float:right;
`

class Filter extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {t,filterChange,roleId,initDeleteDialog,initDialog}=this.props
    return (
      <Div>
          {
            ((roleId==1)||(roleId==2))&&
            (<Select defaultValue={0} style={{width:250}} onChange={(value)=>{filterChange('type',value)}}>
              <Option value={0}>{t("运营商")}</Option>
              <Option value={1}>{t("代理")}</Option>
            </Select>)
          }
          { 
            roleId==3&&(
              <DeleteButton type="danger" onClick={initDeleteDialog}>{t('Delete')}</DeleteButton>
            )
          }
          {
            (roleId==3||roleId==5||roleId==7)&&(
              <AddButton type="primary" onClick={initDialog}>{t('Upload IMEI')}</AddButton>
            )
          }
      </Div>
    )
  }
}

const mapStateToProps = (state)=>{
  return {
    roleId:state.roleId
  }
}

export default connect(mapStateToProps)(withTranslation()(Filter));